import {Provider} from '@angular/core';
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from '../../../core/shared/test/data/test-harness.types';
import {
    XxDialogBoxObjectDocumentComponent
} from '../page/dialog-box-object-documents/dialog-box-object-documents.component';
import {XxObjectDocumentComponent} from '../page/object-documents/object-documents.component';
import {XxConfigPage} from '../page/overview/config/xx-config.page';
import {XxTablePage} from '../page/overview/tables/xx-table.page';
import {XxWidgetPage} from '../page/overview/widgets/xx-widget.page';
import {XxPersonExternalFlatComponent} from '../page/overview/widgets/xx-person-external-flat.component';

const xxModuleEntry: TestModuleDefinition = {
    key: 'xx',
    label: 'Tech Test (xx)',
    components: [
        {
            key: 'XxDialogBoxObjectDocumentComponent',
            component: XxDialogBoxObjectDocumentComponent,
            selector: 'mvs-xx-dialog-box-object-document-component',
            type: 'Component',
            label: 'xx dialog box object document'
        },
        {
            key: 'XxObjectDocumentComponent',
            component: XxObjectDocumentComponent,
            selector: 'Create new scratch file from selection',
            type: 'Component',
            label: 'xx object document Component'
        },
        {
            key: 'XxConfigPage',
            component: XxConfigPage,
            selector: 'mvs-xx-config-page',
            type: 'Component',
            label: 'xx config page'
        },
        {
            key: 'XxTablePage',
            component: XxTablePage,
            selector: 'mvs-xx-table-page',
            type: 'Component',
            label: 'xx table page'
        },
        {
            key: 'XxWidgetPage',
            component: XxWidgetPage,
            selector: 'mvs-xx-widget-page',
            type: 'Component',
            label: 'xx widget page'
        },
        {
            // TM-1000001960: Clean-Core External Side-Car — QL flatten display
            key: 'XxPersonExternalFlatComponent',
            component: XxPersonExternalFlatComponent,
            selector: 'mvs-xx-person-external-flat',
            type: 'Component',
            label: 'xx Person External Flat (QL flatten)'
        },
    ]
}

export const XX_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: xxModuleEntry, multi: true}
];
